import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
export const Contact = () => {
  return <div className="min-h-screen bg-neutral-light pt-24 pb-20" data-id="element-1238">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1239">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-1240">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl font-serif font-bold text-primary-900 mb-4" data-id="element-1241">
            Get in Touch
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-text-light" data-id="element-1242">
            Have questions about verification, listings, or partnerships? Our
            team is here to help.
          </motion.p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-1243">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-3xl shadow-soft border border-neutral-200 p-8 md:p-10" data-id="element-1244">
            <h2 className="text-2xl font-serif font-bold text-primary-900 mb-6" data-id="element-1245">
              Send a Message
            </h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-1246">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-1247">
                <div data-id="element-1248">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1249">
                    Full Name
                  </label>
                  <input type="text" placeholder="John Doe" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1250" />
                </div>
                <div data-id="element-1251">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1252">
                    Email Address
                  </label>
                  <input type="email" placeholder="john@example.com" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1253" />
                </div>
              </div>
              <div data-id="element-1254">
                <label className="block text-sm font-bold text-text mb-2" data-id="element-1255">
                  Subject
                </label>
                <select className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1256">
                  <option data-id="element-1257">General Inquiry</option>
                  <option data-id="element-1258">Verification Support</option>
                  <option data-id="element-1259">Payment Issue</option>
                  <option data-id="element-1260">Report a Listing</option>
                </select>
              </div>
              <div data-id="element-1261">
                <label className="block text-sm font-bold text-text mb-2" data-id="element-1262">
                  Message
                </label>
                <textarea rows={5} placeholder="How can we help you?" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none resize-none" data-id="element-1263"></textarea>
              </div>
              <button type="submit" className="w-full bg-primary-900 hover:bg-primary-800 text-white py-4 rounded-xl font-bold transition-colors flex items-center justify-center gap-2 shadow-lg" data-id="element-1264">
                Send Message <Send size={18} data-id="element-1265" />
              </button>
            </form>
          </motion.div>

          {/* Contact Info & Map */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} className="space-y-8" data-id="element-1266">
            <div className="bg-primary-900 text-white rounded-3xl shadow-soft p-8 md:p-10" data-id="element-1267">
              <h2 className="text-2xl font-serif font-bold mb-8" data-id="element-1268">
                Contact Information
              </h2>
              <div className="space-y-6" data-id="element-1269">
                <div className="flex items-start gap-4" data-id="element-1270">
                  <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center shrink-0" data-id="element-1271">
                    <MapPin className="text-secondary" size={24} data-id="element-1272" />
                  </div>
                  <div data-id="element-1273">
                    <h4 className="font-bold mb-1" data-id="element-1274">Office Address</h4>
                    <p className="text-primary-200 text-sm leading-relaxed" data-id="element-1275">
                      14 Maitama Crescent
                      <br data-id="element-1276" />
                      Abuja, FCT
                      <br data-id="element-1277" />
                      Nigeria
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-1278">
                  <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center shrink-0" data-id="element-1279">
                    <Phone className="text-secondary" size={24} data-id="element-1280" />
                  </div>
                  <div data-id="element-1281">
                    <h4 className="font-bold mb-1" data-id="element-1282">Phone</h4>
                    <p className="text-primary-200 text-sm" data-id="element-1283">
                      +234 (0) 800 AMU REAL
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-1284">
                  <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center shrink-0" data-id="element-1285">
                    <Mail className="text-secondary" size={24} data-id="element-1286" />
                  </div>
                  <div data-id="element-1287">
                    <h4 className="font-bold mb-1" data-id="element-1288">Email</h4>
                    <p className="text-primary-200 text-sm" data-id="element-1289">support@amu.ng</p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-1290">
                  <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center shrink-0" data-id="element-1291">
                    <Clock className="text-secondary" size={24} data-id="element-1292" />
                  </div>
                  <div data-id="element-1293">
                    <h4 className="font-bold mb-1" data-id="element-1294">Business Hours</h4>
                    <p className="text-primary-200 text-sm" data-id="element-1295">
                      Mon - Fri: 9:00 AM - 5:00 PM
                      <br data-id="element-1296" />
                      Sat - Sun: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map Mockup */}
            <div className="h-64 rounded-3xl overflow-hidden shadow-soft relative border border-neutral-200" data-id="element-1297">
              <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&q=80&w=1000" alt="Map Location" className="w-full h-full object-cover" data-id="element-1298" />
              <div className="absolute inset-0 bg-primary-900/10" data-id="element-1299"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-1300">
                <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center text-white shadow-glow animate-bounce" data-id="element-1301">
                  <MapPin size={24} data-id="element-1302" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
};